// @ts-check
import { acceptHMRUpdate, defineStore } from 'pinia';

export const useWarehouseStore = defineStore('warehouse', {
  state: () => ({
    listaExistenciasMovMerc: [],
    listaExistenciasSeleccionadasMovMerc: [],
  }),
  persist: {
    paths: [],
  },
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useWarehouseStore, import.meta.webpackHot));
}
